import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import React, { useEffect, useState } from 'react';
import { useOrg } from '../hooks/useOrg';
import Question from './Question';
import QuestionForm from './QuestionForm';
export default function Questions(_ref) {
  var _ref$slug = _ref.slug,
      slug = _ref$slug === void 0 ? window.location.pathname : _ref$slug;

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId,
      apiHost = _useOrg.apiHost;

  var _useState = useState([]),
      questions = _useState[0],
      setQuestions = _useState[1];

  var getQuestions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, _yield$response$json, questions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(apiHost + "/api/questions", {
                method: 'POST',
                body: JSON.stringify({
                  organizationId: organizationId,
                  slug: slug,
                  published: true,
                  perPage: 100
                })
              });

            case 2:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", []);

            case 5:
              _context.next = 7;
              return response.json();

            case 7:
              _yield$response$json = _context.sent;
              questions = _yield$response$json.questions;
              return _context.abrupt("return", questions);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getQuestions() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getQuestions().then(function (questions) {
      setQuestions(questions);
    });
  }, []);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getQuestions().then(function (questions) {
                setQuestions(questions);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, questions && questions.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "squeak-questions"
  }, questions.map(function (question) {
    return /*#__PURE__*/React.createElement("li", {
      key: question.question.id
    }, /*#__PURE__*/React.createElement(Question, _extends({
      onSubmit: handleSubmit
    }, question)));
  }))), /*#__PURE__*/React.createElement(QuestionForm, {
    onSubmit: handleSubmit,
    organizationId: organizationId,
    formType: "question"
  }));
}